import {Box, useTheme} from "@mui/material";
import FilledButton from "./buttons/FilledButton";
import {observer} from "mobx-react";
import FormDateField from "./fields/FormDateField";

function ActionOnDate({dateLabel, field, onClick, buttonLabel, buttonLoading= false, minDate = null}) {
    const theme = useTheme();
    const style = styles(theme)
    const isButtonDisabled = !field.isValid || buttonLoading

    return (
        <Box sx={style.dateDisablerContainer}>
            <FormDateField field={field} label={dateLabel} minDate={minDate}/>
            <FilledButton onClick={() => onClick()} disabled={isButtonDisabled}>
                {buttonLabel}
            </FilledButton>
        </Box>
    )
}

const styles = (theme) => ({
    dateDisablerContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(2)
    },
})

export default observer(ActionOnDate)